import Vue from 'vue';

import { SpinnerPlugin } from 'bootstrap-vue/esm/components/spinner';
import { ButtonPlugin } from 'bootstrap-vue/esm/components/button';
import { LayoutPlugin } from 'bootstrap-vue/esm/components/layout';
import { CardPlugin } from 'bootstrap-vue/esm/components/card';
import { NavbarPlugin } from 'bootstrap-vue/esm/components/navbar';
import { BreadcrumbPlugin } from 'bootstrap-vue/esm/components/breadcrumb'
import { FormPlugin } from 'bootstrap-vue/esm/components/form'
import { FormGroupPlugin } from 'bootstrap-vue/esm/components/form-group';
import { FormInputPlugin } from 'bootstrap-vue/esm/components/form-input';
import { FormSelectPlugin } from 'bootstrap-vue/esm/components/form-select';

[LayoutPlugin, NavbarPlugin, CardPlugin, BreadcrumbPlugin, FormPlugin, FormGroupPlugin, FormInputPlugin, FormSelectPlugin, ButtonPlugin, SpinnerPlugin].forEach((plugin) => Vue.use(plugin));

